'use client'

import { CSSProperties } from 'react'
import {
  IconBuilding,
  IconHome2,
  IconPencil,
  IconTrash
} from '@tabler/icons-react'

import { FormMode } from 'shared/types/forms'
import { useModal } from 'shared/ui/Modal/useModal'

import ModalAddDeliveryAddress from '../submodules/addresses/components/ModalAddDeliveryAddress'
import ModalRemoveDeliveryAddress from '../submodules/addresses/components/ModalAddDeliveryAddress/ModalRemoveDeliveryAddress'
import ModalAddInvoiceAddress from '../submodules/addresses/components/ModalAddInvoiceAddress'
import ModalRemoveInvoiceAddress from '../submodules/addresses/components/ModalAddInvoiceAddress/ModalRemoveInvoiceAddress'
import {
  CustomerAddress,
  CustomerInvoiceAddress
} from '../submodules/addresses/types'

import ProfileAddressInvoiceDetails from './ProfileAddressSingleItemDetails'

import styles from './ProfileAddressSingleItem.module.scss'

interface ProfileAddressSingleItemProps {
  address: CustomerAddress | CustomerInvoiceAddress
  type: 'delivery' | 'invoice'
  id?: string
}

const ProfileAddressSingleItem = ({
  address,
  id,
  type
}: ProfileAddressSingleItemProps) => {
  // Manage add delivery address modal state
  const {
    isModalOpen: isModalAddDeliveryAddressOpen,
    openModal: openModalAddDeliveryAddress,
    closeModal: closeModalAddDeliveryAddress
  } = useModal()

  return (
    <div className={styles.wrapper} id={id}>
      <div
        className={styles.iconWrapper}
        id='profile_address_icon'
        color={address.iconColor || ''}
        style={
          address.iconColor
            ? ({ '--icon-color': address.iconColor } as CSSProperties)
            : undefined
        }
      >
        {address.iconType === 'home' ? <IconHome2 /> : <IconBuilding />}
      </div>
      <div className={styles.addressWrapper}>
        <h3 className={styles.addressName}>{address.name}</h3>
        <div className={styles.detailsWrapper}>
          <ProfileAddressInvoiceDetails address={address} />
          {type === 'delivery' ? (
            <div className={styles.buttonsWrapper}>
              <ModalAddDeliveryAddress
                isOpen={isModalAddDeliveryAddressOpen}
                handleOpen={openModalAddDeliveryAddress}
                handleClose={closeModalAddDeliveryAddress}
                address={address as CustomerAddress}
                mode={FormMode.edit}
                trigger={
                  <div
                    className={styles.editButton}
                    id='profile_edit_delivery_address_button'
                    aria-label='Edytuj adres'
                  >
                    <IconPencil />
                  </div>
                }
              />
              <ModalRemoveDeliveryAddress
                address={address as CustomerAddress}
                trigger={
                  <div
                    className={styles.removeButton}
                    id='profile_remove_delivery_address_button'
                    aria-label='Usuń adres'
                  >
                    <IconTrash />
                  </div>
                }
              />
            </div>
          ) : (
            <div className={styles.buttonsWrapper}>
              <ModalAddInvoiceAddress
                address={address as CustomerInvoiceAddress}
                mode={FormMode.edit}
                trigger={
                  <div
                    className={styles.editButton}
                    id='profile_edit_invoice_address_button'
                    aria-label='Edytuj adres'
                  >
                    <IconPencil />
                  </div>
                }
              />
              <ModalRemoveInvoiceAddress
                address={address as CustomerInvoiceAddress}
                trigger={
                  <div
                    className={styles.removeButton}
                    id='profile_remove_invoice_address_button'
                    aria-label='Usuń adres'
                  >
                    <IconTrash />
                  </div>
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProfileAddressSingleItem
